import styled from '@mui/material/styles/styled';
import { Bike } from '@gympass/tai-chi/illustrations';

export const DefaultErrorIllustration = styled(Bike)(() => ({
  '--de-illustration-y-offset': '3.875rem',
  '--de-illustration-x-offset': '1.625rem',
  marginBlockStart: 'calc(var(--de-illustration-y-offset) * -1)',
  marginBlockEnd: 'calc(var(--de-illustration-y-offset) * -1)',
  marginInlineStart: 'calc(var(--de-illustration-x-offset) * -1)',
  marginInlineEnd: 'calc(var(--de-illustration-x-offset) * -1)',
}));
